import { FunctionComponent, memo } from "react";
import { IProps } from "./explore-tag-group.types";
import ExploreLink from "components-for/navigation/explore-link";
import useTags from "hooks-for/tags/use-tags";
import { getDefaultRouteUrls } from "utilities/get-default-route-urls";
import Page from "constants/page";
import "./explore-tag-group.scss";

/**
 * A link that will take the user to the explore screen with all the tags for the given group selected.
 * @param props.tagGroupId The ID of the tag group that will be displayed on the explore screen.
 */
const ExploreTagGroup: FunctionComponent<IProps> = ({ tagGroupId }) => {
    const { parameters } = getDefaultRouteUrls()[Page.Explore];
    const { data: tags } = useTags(
        {},
        { select: (tags) => tags.filter((tag) => tag.tagGroupId === tagGroupId).map((tag) => tag.tagId) }
    );
    return <ExploreLink parameters={{ ...parameters, tagId: tags }} />;
};

export default memo(ExploreTagGroup);
